<template>
  <div class="setup-content contact-info" id="step-5">
    <div class="form-row justify-content-between">
      <div>
        <h3 class="color-darkblue">Other Charges</h3>
      </div>
      <div v-if="viewAllfields" class="verified-checkbox mr-4">
        <div class="form-group row claim-verified-checkbox pt-7">
          <label for="other_section_verified" class="control-label claim-mr-2">Verified:</label>
          <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="other_section_verified" id="other_section_verified" />
        </div>
      </div>
    </div>
    <div class="table-responsive-sm mt-2">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" class="" style="width: 4%;">Line #</th>
            <th scope="col" class="" style="width: 8%;">Charge Type</th>
            <th scope="col">Description</th>
            <th scope="col" class="text-left">Vendor Name</th>
            <th scope="col" class="text-left">Vendor Invoice #</th>
            <th scope="col" class="text-left">Dealer Cost</th>
            <th scope="col" class="text-left">Amount Requested</th>
            <!-- the fields below should be visible only to the admin users -->
            <th scope="col" class="text-left">Amount Approved</th>
            <th scope="col" class="text-left">Comments</th>
            <th scope="col" class="text-left" style="width: 15%;">Attachment Required</th>
            <th scope="col"> Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <v-select v-model="row.chargeType" :id="'chargeType' + index" :name="'chargeType' + index" label="text"
                :options="chargeTypeArr" @input="calculateSubletChargesAmount()" placeholder="Select Charge Type"
                :disabled="dealerFieldsDisabled || disableAllFields" class='custom-ci-auto-search contract-data'
                @change="handleChargeTypeChange($event, index)">
              </v-select>
              <div class="field-error ml-0">{{ row.chargeTypeErrorMsg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Description" v-model="row.description" style="width:99% !important"
                :id="'srt' + index" :name="'srt' + index" class="vgt-input" :disabled="dealerFieldsDisabled || disableAllFields">
              <div class="field-error ml-0">{{ row.descriptionErrorMsg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Vendor Name" v-model="row.vendorName" style="width:99% !important"
                :id="'vendorName' + index" :name="'vendorName' + index" class="vgt-input text-left"
                :disabled="dealerFieldsDisabled || disableAllFields">
              <div class="field-error ml-0">{{ row.vendorNameErrorMsg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Vendor Invoice #" v-model="row.vendorInvoiceNumber"
                style="width:99% !important" :id="'vendorInvoiceNumber' + index" :name="'vendorInvoiceNumber' + index"
                class="vgt-input text-left" :disabled="dealerFieldsDisabled || disableAllFields">
              <div class="field-error ml-0">{{ row.vendorInvoiceNumberErrorMsg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Dealer Cost" v-model="row.dealerCost" :id="'dealerCost' + index"
                style="width:99% !important" :name="'dealerCost' + index" class="vgt-input text-right"
                v-on:keyup="calculateSubletChargesAmount()" @keypress="filterNumericValue"
                :disabled="dealerFieldsDisabled || disableAllFields">
              <div class="field-error ml-0">{{ row.dealerCostErrorMsg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Amount Requested" v-model="row.amountRequested" id="amountRequested"
                v-on:keyup="calculateSubletChargesAmount()" name="amountRequested" style="width:99% !important"
                class="vgt-input text-right" @keypress="filterNumericValue" :disabled="dealerFieldsDisabled || disableAllFields">
              <div class="field-error ml-0">{{ row.amountRequestedErrorMsg }}</div>
            </td>
            <!-- the fields below should be visible only to the admin users -->
            <td>
              <input type="text" placeholder="Amount Approved" v-model="row.amountApproved" id="amountApproved"
                v-on:keyup="calculateSubletChargesAmount()" name="amountApproved" style="width:99% !important"
                class="vgt-input text-right" @keypress="filterNumericValue" :disabled="!viewAllfields || disableAllFields">
              <div class="field-error ml-0">{{ row.amountApprovedErrorMsg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Comments" v-model="row.comments" id="comments" name="comments"
                style="width:99% !important" class="vgt-input text-left" :disabled="!viewAllfields || disableAllFields || claimStatus == 'In Process'">
            </td>
            <td>
              <template v-if="row.fileLink == null">
                <div class="custom-file">
                  <input type="file" :id="'attachmentRequired_' + index" :name="'attachmentRequired_' + index"
                    @change="handleSelectedFile($event, index)" :disabled="disableAllFields">
                  <label class="custom-file-label" :for="'attachmentRequired_' + index">Choose File</label>
                  <br>
                  <span class="file-name">{{ row.fileName || 'No file chosen' }}</span>
                </div>
                <div v-if="row.fileErrorMsg" class="field-error ml-0">{{ row.fileErrorMsg }}</div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="col d-flex align-items-center">
                    <a v-on:click="goToGetDocumentPath($event, row.fileLink)" title="View Part Attachment"
                      href="javascript:void(0);" style="font-size: 15px;">
                      <i class="fp-text-document"></i> Attached File
                    </a>
                    <a href="javascript:void(0);" style="margin-left: 15px;margin-top: 4px;"
                      v-on:click="removeFileLink(index);" :class="{ 'custom-disabled-link': disableAllFields || claimStatus == 'In Process' }" class="ms-1">
                      <i class="fp-remove"></i>
                    </a>
                  </div>
                </div>
              </template>
            </td>
            <td class="text-center valign-middle">
              <template v-if="userObj.id == row.created_by">
                <a href="javascript:void(0);" :class="{ 'custom-disabled-link': disableAllFields }" v-on:click="removeItem(index);"> <i class="fp-delete"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <template>
        <button type="submit" :disabled="disableAllFields || claimStatus == 'In Process'" v-on:click.prevent="addRow()" class="btn btn-primary">
          <i class="fp-add"></i> Add Other Charge
        </button>
      </template>
    </div>

    <!-- travel details -->
    <div class="table-responsive-sm mt-2">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" class="" style="width: 4%">Line #</th>
            <th scope="col" class="">Travel Type</th>
            <th scope="col" class="text-left" style="width: 15%">UOM</th>
            <th scope="col" class="text-left">Requested</th>
            <th scope="col" class="text-left">Dealer Rate</th>
            <th scope="col" class="text-left">Amount Requested</th>
            <!-- the fields below should be visible only to the admin users -->
            <th scope="col" class="text-left">Amount Approved</th>
            <th scope="col" class="text-left">Comments</th>
            <th scope="col" class="text-left">Action</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in travelRows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <v-select v-model="row.travelType" :id="'travelType' + index" :name="'travelType' + index" label="text"
                :options="travelTypeArr" placeholder="Select Travel Type" class='custom-ci-auto-search contract-data'
                @input="handleTravelTypeChange(index)" :disabled="dealerFieldsDisabled || disableAllFields"
                @change="travelTypeChanged($event, index)">
              </v-select>
              <div class="field-error ml-0">{{ row.travelTypeErroMsg }}</div>
            </td>
            <td>
              <v-select v-model="row.uom" :id="'uom' + index" :name="'uom' + index" label="text" :options="row.uomArr"
                placeholder="Select UOM" class='custom-ci-auto-search contract-data' :disabled="dealerFieldsDisabled || disableAllFields"
                @change="travelTypeUOMChanged($event, index)">
              </v-select>
              <div class="field-error ml-0">{{ row.uomErrorMsg }}</div>
            </td>
            <td>
              <input type="number" v-model="row.requested" style="width:99% !important" :id="'requested_' + index"
                :name="'requested' + index" class="vgt-input text-right" placeholder="Requested"
                :disabled="dealerFieldsDisabled || disableAllFields" @keypress="filterNumericValue"
                v-on:keyup="calculateTravelChargesAmount()">
              <div class="field-error ml-0">{{ row.requestedErrorMsg }}</div>
            </td>
            <td>
              <input type="text" v-model="row.dealerRate" style="width:99% !important" :id="'dealerRate_' + index"
                :name="'dealerRate' + index" class="vgt-input text-right" placeholder="Dealer Rate"
                v-on:keyup="calculateTravelChargesAmount()" @keypress="filterNumericValue" disabled>
              <div class="field-error ml-0">{{ row.dealerRateErrorMsg }}</div>
            </td>
            <td>
              <input type="text" v-model="row.amountRequested" style="width:99% !important"
                v-on:keyup="calculateTravelChargesAmount()" :id="'amountRequested_' + index"
                :name="'amountRequested' + index" class="vgt-input text-right" placeholder="Amount Requested"
                @keypress="filterNumericValue" disabled>
              <div class="field-error ml-0">{{ row.amountRequestedErrorMsg }}</div>
            </td>
            <!-- the fields below should be visible only to the admin users -->
            <td>
              <input type="text" v-model="row.amountApproved" style="width:99% !important"
                v-on:keyup="calculateTravelChargesAmount()" :id="'amountApproved_' + index"
                :name="'amountApproved' + index" class="vgt-input text-right" placeholder="Amount Approved"
                @keypress="filterNumericValue" :disabled="!viewAllfields || disableAllFields">

              <div class="field-error ml-0">{{ row.approvedAmountErrorMsg }}</div>
            </td>
            <td>
              <input type="text" v-model="row.comments" style="width:99% !important" :id="'comments_' + index"
                :name="'comments' + index" class="vgt-input text-left" placeholder="Comment" :disabled="!viewAllfields || disableAllFields || claimStatus == 'In Process'">
            </td>
            <td class="text-center valign-middle">
              <template v-if="userObj.id == row.created_by">
                <a href="javascript:void(0);" :class="{ 'custom-disabled-link': disableAllFields }" v-on:click="removeTravelItem(index);"> <i class="fp-delete"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <template>
        <button type="submit" :disabled="disableAllFields || claimStatus == 'In Process'" v-on:click.prevent="addTravelRow()" class="btn btn-primary">
          <i class="fp-add"></i> Add Travel Charges
        </button>
      </template>
    </div>
    <!-- travel details ends -->
    <!-- other expenses type Repairing Location -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white radius-5 p-3">
            <h3 class="color-darkblue"> Repairing Location </h3>
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-primary">
                  <th class="text-center">Work Location (Destination)</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td :class="{'text-center': true, 'require': travelRows.length > 0}">Company Name</td>
                  <td>
                    <input type="text" placeholder="Company Name" v-model="companyName" id="companyName"
                      name="companyName" style="width:99% !important" class="vgt-input text-left"
                      :disabled="dealerFieldsDisabled || disableAllFields">
                    <div class="field-error ml-0">{{ company_name_error_msg }}</div>
                  </td>
                </tr>
                <tr>
                  <td :class="{'text-center': true, 'require': travelRows.length > 0}">Street Address</td>
                  <td>
                    <input type="text" placeholder="Street Address" v-model="streetAddress" id="streetAddress"
                      name="streetAddress" style="width:99% !important" class="vgt-input text-left"
                      :disabled="dealerFieldsDisabled || disableAllFields">
                    <div class="field-error ml-0">{{ street_error_msg }}</div>
                  </td>
                </tr>
                <tr>
                  <td :class="{'text-center': true, 'require': travelRows.length > 0}">City</td>
                  <td>
                    <input type="text" placeholder="City" v-model="city" id="city" name="city"
                      style="width:99% !important" class="vgt-input text-left" :disabled="dealerFieldsDisabled || disableAllFields">
                    <div class="field-error ml-0">{{ city_error_msg }}</div>
                  </td>
                </tr>
                <tr>
                  <td :class="{'text-center': true, 'require': travelRows.length > 0}">{{zip_postal}}</td>
                  <td>
                    <input type="text" :placeholder="zip_postal" v-model="zipCode" id="zipCode" name="zipCode"
                      style="width:99% !important" class="vgt-input text-left" :disabled="dealerFieldsDisabled || disableAllFields">
                    <div class="field-error ml-0">{{ zip_error_msg }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
    <!-- other expenses type Repairing Location Ends -->
    <!-- Summary Section -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white radius-5 p-3">
            <h3 class="color-darkblue"> Other Charges Summary </h3>
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-primary">
                  <th class="text-center">Section Summary</th>
                  <th class="text-center">Requested</th>
                  <th class="text-center">Adjusted</th>
                  <th class="text-center">Approved</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr class="table-secondary" v-for="(row, index) in otherChargesTotalTable" :key="index">
                  <td>{{ row.heading }}</td>
                  <td class="text-center">{{ row.claimed_amount }}</td>
                  <td class="text-center">{{ row.processed_amount }}</td>
                </tr> -->
                <tr class="table-secondary">
                  <td class="text-center">Sublet</td>
                  <td class="text-center">$ {{ amountFormat(totalSubletRequestedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalSubletAdjustedAmount, 2, 'total')
                    }}
                  </td>
                  <td class="text-center">$ {{ amountFormat(totalSubletApprovedAmount) }}</td>
                </tr>
                <tr class="table-secondary">
                  <td class="text-center">Travel</td>
                  <td class="text-center">$ {{ amountFormat(totalTravelRequestedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalTravelAdjustedAmount, 2, 'total')
                    }}
                  </td>
                  <td class="text-center">$ {{ amountFormat(totalTravelApprovedAmount) }}</td>
                </tr>
                <tr class="table-secondary">
                  <td class="text-center">Total</td>
                  <td class="text-center">$ {{ amountFormat(totalRequestedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalAdjustedAmount, 2, 'total') }}
                  </td>
                  <td class="text-center">$ {{ amountFormat(totalApprovedAmount) }}</td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Summary Section Ends -->
    <template>
      <div class="alert alert-warning hide w-50">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <strong class="errormsg"></strong>
      </div>
    </template>

  </div>
</template>
<script>
import Vue from "vue";
import { contractMixins } from '../../mixins/contractMixins';
import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";

Vue.component("loading-content", LoadingContent);

export default {
  name: "EvOtherChargesTab",
  mixins: [commonMixins, contractMixins],
  props: {
    viewAllfields: {
      type: Boolean,
      default: false
    },
    dealerFieldsDisabled: {
      type: Boolean,
      default: false
    },
    disableAllFields: {
      type: Boolean,
      default: false
    },
    claimStatus: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    rows: [],
    expenseTypeArr: ['FREIGHT', 'OTHER', 'TOWING'],
    disableAll: false,
    travelRows: [],
    company_name: "",
    street_address: "",
    city_id: "",
    state: "",
    zip: "",
    country: "",
    phone_no: "",
    otherChargesTotalTable: [],
    stateArr: [],
    cityArr: [],
    location_id: "",
    locationArr: [],
    invoiceArr: [],
    state_error_msg: "",
    city_error_msg: "",
    street_error_msg: "",
    location_error_msg: "",
    zip_error_msg: "",
    company_name_error_msg: '',
    phone_no_error_msg: "",
    mileRate: 0,
    kmRate: 0,
    section_verified: false,
    chargeTypeArr: ['Towing', 'Sublet'],
    uomArr: ["MI", "KM", "Hours"],
    travelTypeArr: ["Distance", "Time"],
    totalSubletRequestedAmount: 0,
    totalSubletAdjustedAmount: 0,
    totalSubletApprovedAmount: 0,
    totalTravelRequestedAmount: 0,
    totalTravelAdjustedAmount: 0,
    totalTravelApprovedAmount: 0,
    totalRequestedAmount: 0,
    totalAdjustedAmount: 0,
    totalApprovedAmount: 0,
    companyName: "",
    streetAddress: "",
    city: "",
    zipCode: "",
    otherChargeDetailId: "",
    rowsToDelete: [],
    travelRowsToDelete: [],
    timeTravelRate: '',
    distanceTravelRate: '',
    userObj: JSON.parse(localStorage.getItem("user_obj")),
    initialOtherChargesData: '',
    currentOtherChargesData: ''
  }),
  mounted() {
    var self = this;
    self.loadFieldData(['location']);
  },
  methods: {
    handleChargeTypeChange(value, index){
      if(
        (value == '' || value == null)
        &&
        this.rows[index] != undefined)
      {
        this.rows[index].chargeType = '';
      }
    },
    travelTypeChanged(value, index){
      if(
        (value == '' || value == null)
        &&
        this.travelRows[index] != undefined)
      {
        this.travelRows[index].travelType = '';
      }
    },
    travelTypeUOMChanged(value, index){
      if(
        (value == '' || value == null)
        &&
        this.travelRows[index] != undefined)
      {
        this.travelRows[index].uom = '';
      }
    },
    handleSelectedFile(event, index) {
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        const maxSize = 10000000; // 10MB
        if (file.size > maxSize) {
          this.rows[index].fileErrorMsg = 'The file size is too large. Please upload a file smaller than 10MB.';
          this.rows[index].file = null;
        } else {
          this.rows[index].file = file;
          this.rows[index].fileName = file.name;
          this.rows[index].fileErrorMsg = '';
        }
      }
    },
    gotoNext: function (flag) {
      var self = this;
      // var rowSuccess = self.validateAllRowsForSend();
      // if (rowSuccess) {
      // var success = self.validateLocationFields();
      // if (success){
      self.emitDataToParent();
      self.gotoNextStepMixins(flag);
      // }
      // }
    },
    gotoBack: function (flag) {
      var self = this;
      self.gotoBackStepMixins(flag);
    },
    addRow() {
      var self = this;
      var success = true;
      for (var i = 0; i < self.rows.length; i++) {
        success = self.validateSelectedRow(i);
      }
      if (success) {
        self.rows.push({
          id: "",
          chargeType: "",
          description: "",
          vendorName: "",
          vendorInvoiceNumber: "",
          dealerCost: '',
          amountRequested: '',
          amountApproved: '',
          amountAdjusted: '',
          comments: "",
          chargeTypeErrorMsg: "",
          vendorNameErrorMsg: "",
          vendorInvoiceNumberErrorMsg: "",
          dealerCostErrorMsg: "",
          amountRequestedErrorMsg: "",
          amountApprovedErrorMsg: "",
          amountApprovedChange: false,
          descriptionErrorMsg: '',
          file: '',
          fileName: '',
          fileErrorMsg: '',
          fileLink: null,
          created_by: self.userObj.id
        });
      }
    },
    addTravelRow() {
      var self = this;
      var success = true;
      for (var i = 0; i < self.travelRows.length; i++) {
        success = self.validateTravelSelectedRow(i);
      }
      if (success) {
        self.travelRows.push({
          id: "",
          travelType: "",
          uom: "",
          requested: "",
          dealerRate: '',
          amountRequested: '',
          amountApproved: '',
          amountAdjusted: '',
          comments: '',
          travelTypeErroMsg: '',
          uomErrorMsg: '',
          dealerRateErrorMsg: "",
          amountRequestedErrorMsg: "",
          amountApprovedChange: false,
          requestedErrorMsg: '',
          approvedAmountErrorMsg: '',
          uomArr: ["MI", "KM", "Hours"],
          created_by: self.userObj.id
        });
      }
    },
    removeItem(index) {
      var self = this;
      if (self.rows.length > 0) {
        if (self.rows[index].id != "") {
          self.rowsToDelete.push({
            id: self.rows[index].id
          });
        }
        self.rows.splice(index, 1);
      }
      self.calculateSubletChargesAmount();
    },
    removeTravelItem(index) {
      var self = this;
      if (self.travelRows.length > 0) {
        if (self.travelRows[index].id != "") {
          self.travelRowsToDelete.push({
            id: self.travelRows[index].id
          });
        }
        self.travelRows.splice(index, 1);
      }
      self.calculateTravelChargesAmount();
      if(self.travelRows.length < 1){
        self.clearLocationFieldsErrorMessages();
      }
    },
    populateOtherChargesTable() {
      var self = this;
      self.otherChargesTotalTable.push({
        heading: "Total Other Charges",
        claimed_amount: 0.00,
        processed_amount: 0.00,
      });
    },
    onSearchState(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'state', '');
      }
    },
    onSearchCity(search, loading) {

      var self = this;
      if (search.length > 2) {

        var stateId = self.state.value;
        if (stateId == "") {
          alert("please select state first");
          return;
        }

        loading(true);
        self.searchField(loading, search, 'city', '');
      }
    },
    onSearchInvoice(search, loading) {
      var self = this;
      if (search.length > 3) {
        loading(true);
        self.searchField(loading, search, 'invoice', '');
      }
    },
    validateSelectedRow(index) {
      var self = this;
      var success = true;
      if (self.rows[index] !== undefined) {
        self.clearRowErrorMessages(index);
        if (self.rows[index].chargeType == null || self.rows[index].chargeType == "") {
          self.rows[index].chargeTypeErrorMsg = "Required";
          success = false;
        }
        if (self.rows[index].description == null || self.rows[index].description == "") {
          self.rows[index].descriptionErrorMsg = "Required";
          success = false;
        }
        if (self.rows[index].dealerCost == null || self.rows[index].dealerCost == "") {
          self.rows[index].dealerCostErrorMsg = "Required";
          success = false;
        }
        if (self.rows[index].vendorName == null || self.rows[index].vendorName == "") {
          self.rows[index].vendorNameErrorMsg = "Required";
          success = false;
        }
        if (self.rows[index].vendorInvoiceNumber == null || self.rows[index].vendorInvoiceNumber == "") {
          self.rows[index].vendorInvoiceNumberErrorMsg = "Required";
          success = false;
        }
        if (self.rows[index].amountRequested == null || self.rows[index].amountRequested == "") {
          self.rows[index].amountRequestedErrorMsg = "Required";
          success = false;
        }
        if (self.rows[index].fileLink == null || self.rows[index].fileLink == '') {
          if (self.rows[index].file == null || self.rows[index].file == '') {
            self.rows[index].fileErrorMsg = 'Required';
            success = false;
          }
        }
        if (self.viewAllfields) {
          if (self.rows[index].amountApproved == null || self.rows[index].amountApproved == '') {
            self.rows[index].amountApprovedErrorMsg = 'Required';
            success = false;
          }
        }
      }
      return success;
    },
    validateTravelSelectedRow(index) {
      var self = this;
      var success = true;
      if (self.travelRows[index] !== undefined) {
        self.clearTravelRowErrorMessages(index);
        if (self.travelRows[index].travelType == null || self.travelRows[index].travelType == "") {
          self.travelRows[index].travelTypeErroMsg = "Required";
          success = false;
        }
        if (self.travelRows[index].uom == null || self.travelRows[index].uom == "") {
          self.travelRows[index].uomErrorMsg = "Required";
          success = false;
        }
        if (self.travelRows[index].dealerRate == null || self.travelRows[index].dealerRate == "") {
          self.travelRows[index].dealerRateErrorMsg = "Required";
          success = false;
        }
        if (self.travelRows[index].amountRequested == null || self.travelRows[index].amountRequested == "") {
          self.travelRows[index].amountRequestedErrorMsg = "Required";
          success = false;
        }
        if (self.travelRows[index].requested == null || self.travelRows[index].requested == "") {
          self.travelRows[index].requestedErrorMsg = "Required";
          success = false;
        }
        if (self.viewAllfields) {
          if (self.travelRows[index].amountApproved == null || self.travelRows[index].amountApproved == "") {
            self.travelRows[index].approvedAmountErrorMsg = "Required";
            success = false;
          }
        }
      }
      return success;
    },
    clearRowErrorMessages(index) {
      var self = this;
      self.rows[index].chargeTypeErrorMsg = "";
      self.rows[index].vendorNameErrorMsg = "";
      self.rows[index].vendorInvoiceNumberErrorMsg = "";
      self.rows[index].amountRequestedErrorMsg = "";
      self.rows[index].descriptionErrorMsg = "";
      self.rows[index].amountApprovedErrorMsg = "";
      self.rows[index].dealerCostErrorMsg = "";
      self.rows[index].fileErrorMsg = "";
    },
    clearTravelRowErrorMessages(index) {
      var self = this;
      self.travelRows[index].travelTypeErroMsg = '';
      self.travelRows[index].uomErrorMsg = '';
      self.travelRows[index].dealerRateErrorMsg = '';
      self.travelRows[index].amountRequestedErrorMsg = '';
      self.travelRows[index].requestedErrorMsg = '';
    },
    validateLocationFields() {
      var self = this;
      var success = true;

      if (self.city == null || self.city == "") {
        self.city_error_msg = "City Required";
        success = false;
      }
      if (self.streetAddress == null || self.streetAddress == "") {
        self.street_error_msg = "Street Address Required";
        success = false;
      }
      if (self.companyName == null || self.companyName == "") {
        self.company_name_error_msg = "Company Name Required";
        success = false;
      }
      if (self.zipCode == null || self.zipCode == "") {
        self.zip_error_msg = "Zip Required";
        success = false;
      }
      return success;
    },
    clearLocationFieldsErrorMessages() {
      var self = this;
      self.company_name_error_msg = "";
      self.street_error_msg = "";
      self.city_error_msg = "";
      self.zip_error_msg = "";
    },
    validateAllRowsForSend() {
      var self = this;
      var otherChargesRowSuccess = true;
      var travelRowsSuccess = true
      var overAllSuccess = true;
      var locationSuccess = true;
      for (var i = 0; i < self.rows.length; i++) {
        otherChargesRowSuccess = self.validateSelectedRow(i);
        if (!otherChargesRowSuccess) {
          overAllSuccess = false;
        }
      }
      for (var i = 0; i < self.travelRows.length; i++) {
        travelRowsSuccess = self.validateTravelSelectedRow(i);
        if (!travelRowsSuccess) {
          overAllSuccess = false;
        }
      }
      self.clearLocationFieldsErrorMessages();
      if (self.travelRows.length > 0) {
        locationSuccess = self.validateLocationFields();
        if (!locationSuccess) {
          overAllSuccess = false;
        }
      }

      if (overAllSuccess) {
        return true;
      } else {
        return false;
      }
    },
    emitDataToParent() {
      var self = this;
      self.beforeEmitDataToParent();
      const dataToSend = {
        rows: self.rows,
        travelRows: self.travelRows,
        companyName: self.companyName,
        streetAddress: self.streetAddress,
        city: self.city,
        zipCode: self.zipCode,
        verified: self.section_verified,
        totalSubletRequestedAmount: parseFloat(self.totalSubletRequestedAmount).toFixed(2),
        totalSubletAdjustedAmount: self.totalSubletAdjustedAmount != '0.00' ? Number(self.totalSubletAdjustedAmount).toFixed(2) : '0.00',
        totalSubletApprovedAmount: parseFloat(self.totalSubletApprovedAmount).toFixed(2),
        totalTravelRequestedAmount: parseFloat(self.totalTravelRequestedAmount).toFixed(2),
        totalTravelAdjustedAmount: parseFloat(self.totalTravelAdjustedAmount).toFixed(2),
        totalTravelApprovedAmount: parseFloat(self.totalTravelApprovedAmount).toFixed(2),
        totalRequestedAmount: parseFloat(self.totalRequestedAmount).toFixed(2),
        totalAdjustedAmount: parseFloat(self.totalAdjustedAmount).toFixed(2),
        totalApprovedAmount: parseFloat(self.totalApprovedAmount).toFixed(2),
        otherChargeDetailId: self.otherChargeDetailId,
        rowsToDelete: self.rowsToDelete,
        travelRowsToDelete: self.travelRowsToDelete
      };
      self.$emit("send-other-charges-data-to-parent", dataToSend);
    },
    beforeEmitDataToParent() {
      var self = this;
      if (self.rows.length) {
        self.rows.forEach((row) => {
          if (row.dealerCost) {
            row.dealerCost = self.customFunctionForAmountFormat(row.dealerCost);
            row.dealerCost = parseFloat(row.dealerCost).toFixed(2);
          }
          if (row.amountRequested) {
            row.amountRequested = self.customFunctionForAmountFormat(row.amountRequested);
            row.amountRequested = parseFloat(row.amountRequested).toFixed(2);
          }
          if (row.amountApproved) {
            row.amountApproved = self.customFunctionForAmountFormat(row.amountApproved);
            row.amountApproved = parseFloat(row.amountApproved).toFixed(2);
          }
          if (row.amountAdjusted) {
            row.amountAdjusted = self.customFunctionForAmountFormat(row.amountAdjusted);
            row.amountAdjusted = parseFloat(row.amountAdjusted).toFixed(2);
          }
          if (row.amountApproved == '') {
            row.amountApproved = '0.00';
          }
          if (row.amountAdjusted == '') {
            row.amountAdjusted = '0.00';
          }
        });
      }
      if (self.travelRows.length) {
        self.travelRows.forEach((row) => {
          if (row.dealerRate) {
            row.dealerRate = self.customFunctionForAmountFormat(row.dealerRate);
            row.dealerRate = parseFloat(row.dealerRate).toFixed(2);
          }
          if (row.amountRequested) {
            row.amountRequested = self.customFunctionForAmountFormat(row.amountRequested);
            row.amountRequested = parseFloat(row.amountRequested).toFixed(2);
          }
          if (row.amountApproved) {
            row.amountApproved = self.customFunctionForAmountFormat(row.amountApproved);
            row.amountApproved = parseFloat(row.amountApproved).toFixed(2);
          }
          if (row.amountAdjusted) {
            row.amountAdjusted = self.customFunctionForAmountFormat(row.amountAdjusted);
            row.amountAdjusted = parseFloat(row.amountAdjusted).toFixed(2);
          }
          if (row.amountApproved == '') {
            row.amountApproved = '0.00';
          }
          if (row.amountAdjusted == '') {
            row.amountAdjusted = '0.00';
          }
          if(row.requested){
            row.requested = parseFloat(row.requested).toFixed(2);
          }
        });
      }
    },
    validationFail() {
      var self = this;
      if (self.rows.length) {
        self.rows.forEach((row) => {
          if (row.dealerCost) {
            row.dealerCost = self.formatCurrency(row.dealerCost);
          }
          if (row.amountRequested) {
            row.amountRequested = self.formatCurrency(row.amountRequested);
          }
          if (row.amountApproved) {
            row.amountApproved = self.customFunctionForAmountFormat(row.amountApproved);
          }
          if (row.amountAdjusted) {
            row.amountAdjusted = self.customFunctionForAmountFormat(row.amountAdjusted);
          }
          if (row.amountApproved == '' || row.amountApproved == 0) {
            row.amountApproved = '';
          } else {
            row.amountApproved = self.formatCurrency(row.amountApproved);
          }
        });
      }
      if (self.travelRows.length) {
        self.travelRows.forEach((row) => {
          if (row.dealerRate) {
            row.dealerRate = self.formatCurrency(row.dealerRate);
          }
          if (row.amountRequested) {
            row.amountRequested = self.formatCurrency(row.amountRequested);
          }
          if (row.amountApproved) {
            row.amountApproved = self.customFunctionForAmountFormat(row.amountApproved);
          }
          if (row.amountAdjusted) {
            row.amountAdjusted = self.customFunctionForAmountFormat(row.amountAdjusted);
          }
          if (row.amountApproved == '' || row.amountApproved == 0) {
            row.amountApproved = '';
          } else {
            row.amountApproved = self.formatCurrency(row.amountApproved);
          }
          if(row.requested){
            row.requested = self.customFunctionForAmountFormat(row.requested);
          }
        });
      }
    },
    getOtherChargeData(otherChargeData) {
      var self = this;
      if (otherChargeData[0] != null) {
        self.rows = [];
        self.travelRows = [];
        self.otherChargesTotalTable = [];
        for (let i = 0; i < otherChargeData[0].rows.length; i++) {
          self.rows.push(otherChargeData[0].rows[i]);
        }
        for (let i = 0; i < otherChargeData[0].travelRows.length; i++) {
          self.travelRows.push(otherChargeData[0].travelRows[i]);
          self.travelRows.push({ uomArr: ["MI", "KM", "Hours"] })
        }
        for (let i = 0; i < otherChargeData[0].otherChargesTotalTable.length; i++) {
          self.otherChargesTotalTable.push(otherChargeData[0].otherChargesTotalTable[i]);
        }
        self.location_id = otherChargeData[0].location_id;
        self.zip = otherChargeData[0].zip;
        self.phone_no = otherChargeData[0].phone_no;
        self.city_id = otherChargeData[0].city_id;
        self.state = otherChargeData[0].state;
        self.street_address = otherChargeData[0].street_address;
      }
    },
    getTravelHourRate(hourRate, mileRate) {
      this.mileRate = "$" + this.amountFormat(mileRate);
      for (const row of this.travelRows) {
        if (row.travel == "Travel Hours") {
          row.factor = "$" + this.amountFormat(hourRate);
        } else {
          if (row.selectedUom == "MI") {
            row.factor = this.mileRate;
          }
        }
      }
    },
    calculateSubletChargesAmount(flag = false) {
      var self = this;
      self.totalSubletRequestedAmount = 0;
      self.totalSubletAdjustedAmount = 0;
      self.totalSubletApprovedAmount = 0;

      for (let element of self.rows) {
        // Format amounts and ensure numerical values
        if (element.dealerCost) {
          element.dealerCost = element.dealerCost.replace('$', '').trim();

        }
        if (element.amountRequested) {
          element.amountRequested = element.amountRequested.replace('$', '').trim();

        }
        if (element.amountApproved) {
          element.amountApproved = element.amountApproved.replace('$', '').trim();
        }

        if (element.amountRequested != '') {
          self.totalSubletRequestedAmount += parseFloat(element.amountRequested);
        }

        element.amountAdjusted = '';
        if (element.amountApproved != '') {
          if (element.amountRequested != 0 && element.amountApproved != 0) {
            var amountAdjusted = element.amountApproved - element.amountRequested;
            element.amountAdjusted = amountAdjusted;
            self.totalSubletAdjustedAmount += amountAdjusted;
          }
        }

        if (element.amountApproved != '') {
          self.totalSubletApprovedAmount += parseFloat(element.amountApproved);
        }

        // adding a $ sign
        if (element.dealerCost) {
          element.dealerCost = element.dealerCost ? '$' + element.dealerCost : '$0';
        }
        if (element.amountRequested) {
          element.amountRequested = element.amountRequested ? '$' + element.amountRequested : '$0';
        }
        if (element.amountApproved) {
          element.amountApproved = element.amountApproved ? '$' + element.amountApproved : '$0';
        }
      }

      self.calculateTotals();
    },
    handleTravelTypeChange(index) {
      var self = this;
      if (self.travelRows[index].travelType) {
        if (self.travelRows[index].travelType == "Distance") {
          self.travelRows[index].uomArr = ['MI', 'KM'];
          if (self.travelRows[index].uom == 'Hours') {
            self.travelRows[index].uom = "";
          }
          self.travelRows[index].dealerRate = self.distanceTravelRate;
        } else if (self.travelRows[index].travelType == "Time") {
          self.travelRows[index].uomArr = ['Hours'];
          if (self.travelRows[index].uom != 'Hours') {
            self.travelRows[index].uom = "";
          }
          self.travelRows[index].dealerRate = self.timeTravelRate;
        }
        else {
          self.travelRows[index].uomArr = ['MI', 'KM', 'Hours'];
        }
      } else {
        self.clearTravelFields(index);
      }
      self.calculateTravelChargesAmount();
    },
    clearTravelFields(index) {
      this.travelRows[index].uom = '';
      this.travelRows[index].requested = '';
      this.travelRows[index].dealerRate = '';
      this.travelRows[index].amountRequested = '';
    },
    calculateTravelChargesAmount(flag = false) {
      var self = this;

      self.totalTravelRequestedAmount = 0;
      self.totalTravelAdjustedAmount = 0;
      self.totalTravelApprovedAmount = 0;

      for (let element of self.travelRows) {
        // Format amounts and ensure numerical values
        if (element.dealerRate) {
          element.dealerRate = self.customFunctionForAmountFormat(element.dealerRate);
        }
        if (element.amountRequested) {
          element.amountRequested = self.customFunctionForAmountFormat(element.amountRequested);
        }
        if (element.amountApproved) {
          element.amountApproved = element.amountApproved.replace('$', '').trim();
        }
        if (element.requested !== '') {
          element.requested = self.customFunctionForAmountFormat(element.requested);
        } else {
          element.amountRequested = '';
        }

        if (element.requested != '' && element.dealerRate != '') {
          element.amountRequested = element.requested * element.dealerRate;
        }

        if (element.amountRequested != '') {
          self.totalTravelRequestedAmount += element.amountRequested;
        }

        element.amountAdjusted = '';
        if (element.amountApproved != '') {
          if (element.amountRequested != 0 && element.amountApproved != 0) {
            var amountAdjusted = element.amountApproved - element.amountRequested;
            element.amountAdjusted = amountAdjusted;
            self.totalTravelAdjustedAmount += amountAdjusted;
          }
        }

        if (element.amountApproved != '') {
          self.totalTravelApprovedAmount += parseFloat(element.amountApproved);
        }

        if (element.amountRequested) {
          element.amountRequested = element.amountRequested.toFixed(2);
        }
        // adding a $ sign
        if (element.dealerRate) {
          element.dealerRate = self.formatCurrency(element.dealerRate);
        }
        if (element.amountRequested) {
          element.amountRequested = self.formatCurrency(element.amountRequested);
        }

        if (element.amountApproved) {
          element.amountApproved = element.amountApproved ? '$' + element.amountApproved : '$0';
        }
      }

      self.calculateTotals();
    },
    calculateTotals() {
      var self = this;
      self.totalRequestedAmount = 0;
      self.totalAdjustedAmount = 0;
      self.totalApprovedAmount = 0;

      // FOR SUBLET
      // Ensure values are numbers before summing
      self.totalSubletRequestedAmount = self.amountFormatToFloat(self.totalSubletRequestedAmount);
      self.totalSubletApprovedAmount = self.amountFormatToFloat(self.totalSubletApprovedAmount);

      self.totalAdjustedAmount = parseFloat(self.totalAdjustedAmount) + self.formatAmountToFloatNew(self.totalSubletAdjustedAmount);

      self.totalRequestedAmount = parseFloat(self.totalRequestedAmount) + self.totalSubletRequestedAmount;
      self.totalApprovedAmount = parseFloat(self.totalApprovedAmount) + self.totalSubletApprovedAmount;

      // FOR TRAVELS
      // Ensure values are numbers before summing
      self.totalTravelRequestedAmount = parseFloat(self.totalTravelRequestedAmount);
      self.totalTravelApprovedAmount = parseFloat(self.totalTravelApprovedAmount);

      // Handle parentheses for adjusted amount
      self.totalAdjustedAmount = self.totalAdjustedAmount + parseFloat(self.totalTravelAdjustedAmount);

      self.totalRequestedAmount = parseFloat(self.totalRequestedAmount) + self.totalTravelRequestedAmount;
      self.totalApprovedAmount = parseFloat(self.totalApprovedAmount) + self.totalTravelApprovedAmount;

      var calculationData = {
        totalRequestedAmount: self.totalRequestedAmount,
        totalAdjustedAmount: self.formatAmountToFloatNew(self.totalAdjustedAmount),
        totalApprovedAmount: self.totalApprovedAmount
      };
      self.$emit("send-calculation-other-charges-data-to-parent", calculationData);
    },
    getDataFromParent(otherChargeData) {
      this.populateOtherChargeLineItems(otherChargeData.ev_other_charge_line_items);
      this.populateTravelRowLineItems(otherChargeData.ev_travel_row_line_items);
      this.companyName = otherChargeData.company_name;
      this.streetAddress = otherChargeData.street_address;
      this.city = otherChargeData.city;
      this.zipCode = otherChargeData.zip_code;
      this.totalSubletRequestedAmount = otherChargeData.total_sublet_requested_amount;
      this.totalSubletAdjustedAmount = otherChargeData.total_sublet_adjusted_amount;
      this.totalSubletApprovedAmount = otherChargeData.total_sublet_approved_amount;
      this.totalTravelRequestedAmount = otherChargeData.total_travel_requested_amount;
      this.totalTravelAdjustedAmount = otherChargeData.total_travel_adjusted_amount;
      this.totalTravelApprovedAmount = otherChargeData.total_travel_approved_amount;
      this.totalRequestedAmount = otherChargeData.total_requested_amount;
      this.totalAdjustedAmount = otherChargeData.total_adjusted_amount;
      this.totalApprovedAmount = otherChargeData.total_approved_amount;
      this.otherChargeDetailId = otherChargeData.id;
      this.section_verified = (otherChargeData.verified == 0) ? false : true;
      // todo need to handle the part attachment data data

      this.$nextTick(() => {
        this.populateInitialOtherChargesData(true);
      });
    },
    populateInitialOtherChargesData(flag){
      if(flag) {
        setTimeout(() => {
          this.setInitialValue(flag);
        }, 500);
      } else {
        return this.setInitialValue(flag);
      }
    },
    setInitialValue(flag){
      const processRows = (rows, priceKeys, hasRequestedField = false) => {
        return rows.map(row => {
          let updatedRow = { ...row };

          Object.keys(updatedRow).forEach(key => {
            if (typeof updatedRow[key] === "string" && updatedRow[key].includes("$")) {
              updatedRow[key] = parseFloat(updatedRow[key].replace(/[^0-9.-]+/g, "")).toFixed(2);
            }

            if (priceKeys.includes(key)) {
              updatedRow[key] = updatedRow[key] === "" ? "0.00" : updatedRow[key];

              if (!Number.isNaN(parseFloat(updatedRow[key]))) {
                updatedRow[key] = parseFloat(updatedRow[key]).toFixed(2).toString();
              }
            }

            if (hasRequestedField && key === "requested") {
              let requestedValue = parseFloat(updatedRow[key] || 0);
              updatedRow[key] = requestedValue === 0 ? 0 : requestedValue.toFixed(2).toString();
            }
          });

          return updatedRow;
        });
      };

      const rows = processRows(this.rows, ["amountApproved", "amountAdjusted"]);
      const travel_rows = processRows(this.travelRows, ["amountApproved", "amountAdjusted"], true);

      const otherData = JSON.stringify({
        rows: rows,
        travelRows: travel_rows,
        companyName: this.companyName,
        streetAddress: this.streetAddress,
        city: this.city,
        zipCode: this.zipCode,
        verified: this.section_verified,
        totalSubletRequestedAmount: parseFloat(this.totalSubletRequestedAmount).toFixed(2),
        totalSubletAdjustedAmount: this.totalSubletAdjustedAmount != '0.00' ? Number(this.totalSubletAdjustedAmount).toFixed(2) : '0.00',
        totalSubletApprovedAmount: parseFloat(this.totalSubletApprovedAmount).toFixed(2),
        totalTravelRequestedAmount: parseFloat(this.totalTravelRequestedAmount).toFixed(2),
        totalTravelAdjustedAmount: parseFloat(this.totalTravelAdjustedAmount).toFixed(2),
        totalTravelApprovedAmount: parseFloat(this.totalTravelApprovedAmount).toFixed(2),
        totalRequestedAmount: parseFloat(this.totalRequestedAmount).toFixed(2),
        totalAdjustedAmount: parseFloat(this.totalAdjustedAmount).toFixed(2),
        totalApprovedAmount: parseFloat(this.totalApprovedAmount).toFixed(2),
        otherChargeDetailId: this.otherChargeDetailId,
        rowsToDelete: this.rowsToDelete,
        travelRowsToDelete: this.travelRowsToDelete
      });

      if (flag) {
        this.initialOtherChargesData = '';
        this.initialOtherChargesData = otherData;
      } else {
        this.currentOtherChargesData = '';
        this.currentOtherChargesData = otherData;
        
        return this.initialOtherChargesData !== this.currentOtherChargesData;
      }
    },
    populateOtherChargeLineItems(otherChargeLineItems) {
      for (let i = 0; i < otherChargeLineItems.length; i++) {
        this.rows.push({
          id: otherChargeLineItems[i].id,
          chargeType: otherChargeLineItems[i].charge_type,
          description: otherChargeLineItems[i].description,
          vendorName: otherChargeLineItems[i].vendor_name,
          vendorInvoiceNumber: otherChargeLineItems[i].vendor_invoice_number,
          dealerCost: otherChargeLineItems[i].dealer_cost,
          amountRequested: otherChargeLineItems[i].amount_requested,
          amountApproved: otherChargeLineItems[i].amount_approved == '0.00' ? '' : otherChargeLineItems[i].amount_approved,
          amountAdjusted: otherChargeLineItems[i].amount_adjusted,
          comments: otherChargeLineItems[i].comments,
          amountApprovedChange: otherChargeLineItems[i].amount_requested == otherChargeLineItems[i].amount_approved ? false : true,
          fileLink: (otherChargeLineItems[i].attachment_link != "") ? otherChargeLineItems[i].attachment_link : null,
          file: '',
          fileName: '',
          fileErrorMsg: '',
          created_by: otherChargeLineItems[i].created_by === null ? this.userObj.id : otherChargeLineItems[i].created_by
        });
      }
      this.calculateSubletChargesAmount();
    },
    populateTravelRowLineItems(travelRowLineItems) {
      for (let i = 0; i < travelRowLineItems.length; i++) {
        this.travelRows.push(
          {
            id: travelRowLineItems[i].id,
            travelType: travelRowLineItems[i].travel_type,
            uom: travelRowLineItems[i].uom,
            requested: travelRowLineItems[i].requested,
            dealerRate: travelRowLineItems[i].dealer_rate,
            amountRequested: travelRowLineItems[i].amount_requested,
            amountApproved: travelRowLineItems[i].amount_approved == '0.00' ? '' : travelRowLineItems[i].amount_approved,
            amountAdjusted: travelRowLineItems[i].amount_adjusted,
            comments: travelRowLineItems[i].comments,
            amountApprovedChange: travelRowLineItems[i].amount_requested == travelRowLineItems[i].amount_approved ? false : true,
            uomArr: ["MI", "KM", "Hours"],
            created_by: travelRowLineItems[i].created_by === null ? this.userObj.id : travelRowLineItems[i].created_by
          }
        );
      }
      this.calculateTravelChargesAmount();
    },
    clearAllFields() {
      var self = this;
      self.section_verified = false;

      self.rows = [];
      self.travelRows = [];

      self.companyName = '';
      self.streetAddress = '';
      self.city = '';
      self.zipCode = '';

      self.totalSubletRequestedAmount = 0;
      self.totalSubletAdjustedAmount = 0;
      self.totalSubletApprovedAmount = 0;
      self.totalTravelRequestedAmount = 0;
      self.totalTravelAdjustedAmount = 0;
      self.totalTravelApprovedAmount = 0;
      self.totalRequestedAmount = 0;
      self.totalAdjustedAmount = 0;
      self.totalApprovedAmount = 0;
      self.rowsToDelete = [];
      self.travelRowsToDelete = [];
    },
    goToGetDocumentPath(event, link) {
      event.preventDefault();
      var self = this;
      var path = link;
      var flag = '';
      var id = 0;
      self.getDocumentPath(id, path, flag);
    },
    removeFileLink(index) {
      this.rows[index].fileLink = null;
    },
    populateTravelRate(timeTravelRate, distanceTravelRate) {
      this.timeTravelRate = "$" + timeTravelRate;
      this.distanceTravelRate = "$" + distanceTravelRate;
      this.travelRateChanged();
    },
    travelRateChanged() {
      for (const row of this.travelRows) {
        if (row.travelType == "Distance") {
          row.dealerRate = this.distanceTravelRate;
        } else if (row.travelType == "Time") {
          row.dealerRate = this.timeTravelRate;
        }
      }
      this.calculateTravelChargesAmount();
    }
  },
}
</script>
<style scoped>
.custom-file {
  display: inline-block;
  position: relative;
  width: 100%;
  font-family: Arial, sans-serif;
}

.custom-file input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 2;
}

.custom-file-label {
  display: inline-block;
  background: #007bff;
  color: white;
  border: 1px solid #007bff;
  cursor: pointer;
  z-index: 1;
  user-select: none;
  font-size: 14px;
  border-radius: 4px;
}

.file-name {
  display: block;
  margin-top: 1rem;
  margin-left: 0.2rem;
  font-size: 14px;
  color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvOtherChargeTab.vue